<template>
    <div v-if="isPC" class="content-area">
        <div class="layout-wrapper">
            <img :src="productInfo.pictures[0].filePath" alt="">
            <div class="content">
                <p>{{ productInfo.creatorName }}</p>
                <p v-if="productInfo.school">{{ productInfo.school }}</p>
                <p>{{ productInfo.coCreatorName1 }}</p>
                <p v-if="productInfo.teamBrief">{{ productInfo.teamBrief }}</p>
                <p v-if="productInfo.worksName">{{ productInfo.worksName }}</p>
            </div>
        </div>
    </div>
    <div v-else class="m-content-area">
        <div class="m-layout-wrapper">
            <img :src="productInfo.pictures[0].filePath" alt="">
            <div class="m-content">
                <p>{{ productInfo.creatorName }}</p>
                <p v-if="productInfo.school">{{ productInfo.school }}</p>
                <p>{{ productInfo.coCreatorName1 }}</p>
                <p v-if="productInfo.teamBrief">{{ productInfo.teamBrief }}</p>
                <p v-if="productInfo.worksName">{{ productInfo.worksName }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'YZHDetailPage',
    props: ['id'],
    data() {
        return {
            productInfo: {}
        }
    },
    mounted() {
        this.initData(this.id);
    },
    methods: {
        closeDetail() {
            this.$emit('closeDetail')
        },
        initData(id) {
            let data = this.$allData[this.currentLang] || []
            for (let item of data) {
                if (item.boothNo === id) {
                    this.productInfo = { ...item }
                    break
                }
            }
        }
    }
}
</script>

<style scoped>
.content-area {
    padding-top: 10vh;
    width: 100%;
    min-height: 100%;
    background-color: #f5f5f6;
    box-sizing: border-box;
}

.layout-wrapper {
    width: 120rem;
    margin: 0 auto;
    padding-bottom: 20px;
    font-size: 0px;
    text-align: center;
}

.content {
    margin-left: 20px;
    padding-left: 20px;
    display: inline-block;
    width: 60%;
    border-left: 1px solid #EC6000;
    box-sizing: border-box;
    vertical-align: top;
}

.content p {
    font-size: 2rem;
    color: #000;
    text-align: left;
    margin-bottom: 2rem;
}

.layout-wrapper img {
    width: 30%;
}

.m-content-area {
    padding-top: 4rem;
    width: 100%;
    height: 100%;
    background-color: #f5f5f6;
}

.m-layout-wrapper {
    width: 80%;
    height: 100%;
    margin: 0 auto;
    text-align: center;
}

.m-layout-wrapper img {
    width: 80%;
}

.m-content {
    margin-top: 4rem;
    padding-top: 4rem;
    padding-bottom: 4rem;
    display: block;
    border-top: 1px solid #EC6000;
    box-sizing: border-box;
}

.m-content p {
    font-size: 4rem;
    color: #000;
    text-align: left;
    margin-bottom: 2rem;
}
</style>